<template>
  <div class="onoffswitch">
    <input type="hidden" :name="name" :value="value" />
    <input
      :id="id"
      :class="['onoffswitch-checkbox', { checked: checked }]"
      :name="name"
      type="checkbox"
      :value="toggledValue"
      :checked="checked ? 'checked' : ''"
      :disabled="disabled"
      @click="toggle"
    />
    <label class="onoffswitch-label" :for="id">
      <span
        :class="cssClass"
        :data-on-label="onLabel"
        :data-off-label="offLabel"
      ></span>
      <span class="onoffswitch-switch"></span>
    </label>
  </div>
</template>

<script>
const $ = require('jQuery');
const loader = require('../../loader');
const urlLib = require('../../url');

export default {
  props: {
    href: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    onLabel: {
      type: String,
      required: true
    },
    offLabel: {
      type: String,
      required: true
    },
    bindToHttpParameter: {
      type: String,
      default: null,
      description:
        'When switch is toggled, pjax-reload the page with the new http parameter value attached to url.'
    },
    applyPageFix: {
      type: Boolean,
      default: false,
      description:
        'When reloading the page, make sure to set http `page` parameter to 1.'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cssClass() {
      return this.disabled ? 'onoffswitch-inner disabled' : 'onoffswitch-inner';
    },
    value() {
      return this.checked ? 1 : 0;
    },
    toggledValue() {
      return this.checked ? 0 : 1;
    }
  },
  methods: {
    toggle() {
      let newUrl;

      if (this.bindToHttpParameter) {
        newUrl = urlLib.setUrlParameter(
          document.location.href,
          this.bindToHttpParameter,
          this.value ? '0' : '1'
        );
        if (this.applyPageFix) {
          newUrl = urlLib.setUrlParameter(newUrl, 'page', 1);
        }
      } else {
        newUrl = this.href;
      }

      if (newUrl) {
        loader.showLoader();

        $.pjax({
          url: newUrl
        });
      } else {
        this.$emit('change', this.value);
      }
    }
  }
};
</script>
